import { getFeatureFlags } from 'Hooks/Api/apiFeatureFlag';
import useAsync from 'Hooks/useAsync';

export function useApiFeatureFlags() {
	return useAsync(async () => {
		const response = await getFeatureFlags();
		return response.data;
	}, []);
}